<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ configuracoes.configuracao_id ? "Editar" : "Adicionar" }}
                Configuração
              </div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <!-- <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Status:
                        </label>
                        <select
                          v-model="configuracoes.status"
                          class="form-control"
                        >
                          <option :value="1">Ativo</option>
                          <option :value="0">Inativo</option>
                        </select>
                      </div>
                    </div> -->
                    <div class="row">
                      <div class="form-group col-md-6">
                        <div class="custom-control custom-switch">
                          <input
                            autocomplete="new-password"
                            v-model="configuracoes.judicial"
                            placeholder=""
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitch1"
                          />
                          <label
                            class="custom-control-label"
                            for="customSwitch1"
                            >Exibir a label "É judicial"</label
                          >
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-md-6">
                        <div class="custom-control custom-switch">
                          <input
                            autocomplete="new-password"
                            v-model="configuracoes.sinais_vitais"
                            placeholder=""
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitch2"
                          />
                          <label
                            class="custom-control-label"
                            for="customSwitch2"
                            >Exibir a label "Sinais Vitais"</label
                          >
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-md-6">
                        <div class="custom-control custom-switch">
                          <input
                            autocomplete="new-password"
                            v-model="configuracoes.dificuldade_acesso"
                            placeholder=""
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitch3"
                          />
                          <label
                            class="custom-control-label"
                            for="customSwitch3"
                            >Exibir a label "Paciente com dificuldade de
                            acesso"</label
                          >
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="userPic"> Logo Empresa</label>
                      <div class="user-img">
                        <img
                          v-if="previewImage"
                          :src="previewImage"
                          class="photo"
                        />
                        <img v-else class="photo" />
                      </div>
                      <input
                        type="file"
                        class=""
                        id="userPic"
                        accept="image/*"
                        name="userPic"
                        @change="uploadImage"
                        placeholder
                      />
                    </div>
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <router-link
                        to="/configuracoes"
                        class="btn btn-back mr-1"
                      >
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      companies: [],
      departments: [],
      configuracoes: {
        judicial: 0,
        sinais_vitais: 0,
        dificuldade_acesso: 0,
      },
      companies: {},
      departments: {},
      perfil_usuarios: [],

      errors: undefined,

      previewImage: null,
    };
  },
  computed: {},
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let photo = document.getElementById("userPic");

      fd.append("judicial", self.configuracoes.judicial ? "1" : "0");
      fd.append("sinais_vitais", self.configuracoes.sinais_vitais ? "1" : "0");
      fd.append(
        "dificuldade_acesso",
        self.configuracoes.dificuldade_acesso ? "1" : "0"
      );

      fd.append("_method", "POST");

      fd.append("logo_empresa", photo.files[0] ? photo.files[0] : "");

      if (self.configuracoes.id) {
        fd.append("id", self.configuracoes.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "configuracoes";

      let fd = self.makeFormData();

      if (self.configuracoes.id) {
        api += "/" + self.configuracoes.id;
      }

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/configuracoes");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getConfiguracoes: function (id) {
      const self = this;
      const api = self.$store.state.api + "configuracoes/" + id;

      axios
        .get(api)
        .then((response) => {
          self.configuracoes = response.data.data[0];
          self.configuracoes.judicial =
            self.configuracoes.judicial == "0" ? 0 : 1;
          self.configuracoes.sinais_vitais =
            self.configuracoes.sinais_vitais == "0" ? 0 : 1;
          self.configuracoes.dificuldade_acesso =
            self.configuracoes.dificuldade_acesso == "0" ? 0 : 1;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        console.log(this.previewImage);
      };
    },
  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;
    if (id) {
      self.change_password = false;
      self.getConfiguracoes(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>